import { createAction } from '@reduxjs/toolkit'

export const updateCustomerVerificationCode = createAction<string>('customer/updateCustomerVerificationCode')
export const clearCustomerVerificationCode = createAction('customer/clearCustomerVerificationCode')
